import { render, staticRenderFns } from "./MultiDishForm.vue?vue&type=template&id=2257ace0&lang=pug"
import script from "./MultiDishForm.vue?vue&type=script&lang=js"
export * from "./MultiDishForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports